import React from 'react';
import data from '../lang/arsskyrsla-data.json';
import {Grid, GridItem, useBreakpointValue} from '@chakra-ui/react';
import {getComponentByType} from '../DynamicComponent';
import {BannerHomePage} from '../components';
import Navbar from '../components/navBar/NavBar';

function HomePage() {
    const components = data.versions[0].pages[0].components;
    const cardDataBanner = data.versions[0].pages[0];
    const menuItems = data.versions[0].topMenu.menuItems;

    const isMobile = useBreakpointValue({base: true, md: false});

    return (
        <React.Fragment>
            <Navbar menuItems={menuItems} onHomepage={true}/>
            <BannerHomePage bannerData={cardDataBanner}/>
            <Grid
                templateColumns={`repeat(${isMobile ? 4 : 12}, 1fr)`}
                columnGap={isMobile ? "24px" : "32px"}
                rowGap={isMobile ? "0px" : "20px"}
                pl={isMobile ? "16px" : "48px"}
                pr={isMobile ? "16px" : "48px"}
            >
                <GridItem colStart={isMobile ? 1 : 2} colEnd={isMobile ? 5 : 12}>
                    {components.map((component, index) =>
                        getComponentByType(component.type, component.content, index)
                    )}
                </GridItem>
            </Grid>
        </React.Fragment>
    );
}

export default HomePage;